/**
 * CM > IPS > 침입탐지 프로파일 > 트래픽 학습방어
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix} from '~/utils/restApi'

class PolicyData {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_learn_traffic_policy_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_lrn_trffc_plc_id')) this.modelType = 'ads'
    else this.modelType = modelType
    this.learn_traffic_policy_id = this.getValue(obj, ['ngips_learn_traffic_policy_id', 'ads_lrn_trffc_plc_id'], 'learn_traffic_policy_id')
    this.learn_traffic_policy_ips_prf_id = this.getValue(obj, ['ngips_learn_traffic_policy_ips_prf_id', 'ads_ips_prf_id'], 'learn_traffic_policy_ips_prf_id')
    this.learn_traffic_policy_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_use_yn', 'ads_lrn_trffc_plc_use_yn'], 'learn_traffic_policy_use_yn')
    this.learn_traffic_policy_name = this.getValue(obj, ['ngips_learn_traffic_policy_name', 'ads_lrn_trffc_plc_name'], 'learn_traffic_policy_name')
    this.learn_traffic_policy_default_value = this.getValue(obj, ['ngips_learn_traffic_policy_default_value', 'ads_lrn_trffc_plc_default_value'], 'learn_traffic_policy_default_value')
    this.learn_traffic_policy_min_value = this.getValue(obj, ['ngips_learn_traffic_policy_min_value', 'ads_lrn_trffc_plc_min_value'], 'learn_traffic_policy_min_value')
    this.learn_traffic_policy_max_value = this.getValue(obj, ['ngips_learn_traffic_policy_max_value', 'ads_lrn_trffc_plc_max_value'], 'learn_traffic_policy_max_value')
    this.learn_traffic_policy_auto_learning = this.getValue(obj, ['ngips_learn_traffic_policy_auto_learning', 'ads_lrn_trffc_plc_auto_learning'], 'learn_traffic_policy_auto_learning')
    this.learn_traffic_policy_msg = this.getValue(obj, ['ngips_learn_traffic_policy_msg', 'ads_lrn_trffc_plc_msg'], 'learn_traffic_policy_msg')
    this.learn_traffic_policy_action_yn = this.getValue(obj, ['ngips_learn_traffic_policy_action_yn', 'ads_lrn_trffc_plc_action_yn'], 'learn_traffic_policy_action_yn')
    this.learn_traffic_policy_log_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_log_use_yn', 'ads_lrn_trffc_plc_log_use_yn'], 'learn_traffic_policy_log_use_yn')
    this.learn_traffic_policy_mail_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_mail_use_yn', 'ads_lrn_trffc_plc_mail_use_yn'], 'learn_traffic_policy_mail_use_yn')
    this.learn_traffic_policy_dump_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_dump_use_yn', 'ads_lrn_trffc_plc_dump_use_yn'], 'learn_traffic_policy_dump_use_yn')
    this.learn_traffic_policy_alert_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_alert_use_yn', 'ads_lrn_trffc_plc_alert_use_yn'], 'learn_traffic_policy_alert_use_yn')
    this.learn_traffic_policy_alert_sound_use_yn = this.getValue(obj, ['ngips_learn_traffic_policy_alert_sound_use_yn', 'ads_lrn_trffc_plc_alert_sound_use_yn'], 'learn_traffic_policy_alert_sound_use_yn')
    this.ex_addr_list = this.getValue(obj, ['ex_addr_list', 'excpt_addr_list'], 'ex_addr_list')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
  fromAddForm () {
    const addFormKey = [
      'learn_traffic_policy_id', 'learn_traffic_policy_use_yn', 'learn_traffic_policy_default_value', 'learn_traffic_policy_min_value', 'learn_traffic_policy_action_yn',
      'learn_traffic_policy_max_value', 'learn_traffic_policy_auto_learning', 'learn_traffic_policy_log_use_yn', 'learn_traffic_policy_log_use_yn',
      'learn_traffic_policy_mail_use_yn', 'learn_traffic_policy_dump_use_yn', 'learn_traffic_policy_alert_use_yn', 'learn_traffic_policy_alert_sound_use_yn'
    ]
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      if (addFormKey.includes(key)) ret[orgKey] = this[key]
    })
    return ret
  }
}

class ExceptHostAddForm {
  constructor (obj, modelType = 'ips') {
    this.prf_id = obj.prf_id
    this.modelType = modelType
    this.excpt_host_desc = obj.excpt_host_desc // desc
    this.excpt_list = _.cloneDeep(obj.excpt_list) // 출발지, 목적지
    this.policy_list = _.cloneDeep(obj.policy_list)
  }
  getApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_prf_id: this.prf_id,
        ngips_learn_traffic_policy_msg: this.excpt_host_desc,
        ngips_learn_traffic_policy_excpt_list: _.map(this.excpt_list, o => {
          return {
            ngips_learn_traffic_policy_excpt_host_src_addr_obj_id: o.src_addr_obj_id,
            ngips_learn_traffic_policy_excpt_host_dst_addr_obj_id: o.dst_addr_obj_id
          }
        }),
        ngips_learn_traffic_policy_list: this.policy_list
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_ips_prf_id: this.prf_id,
        ads_lrn_trffc_plc_id_list: this.policy_list,
        ads_lrn_trffc_plc_excpt_list: this.excpt_list
      }
    }
    return {}
  }
}

class ExceptHostGetForm {
  constructor (obj) {
    // ips
    if (_.has(obj, 'ngips_learn_traffic_policy_msg')) {
      this.policy_exc_desc = obj.ngips_learn_traffic_policy_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.ngips_learn_traffic_policy_excpt_src_addr_obj_id,
          src_ip_ver: o.ngips_learn_traffic_policy_excpt_host_src_ip_ver_type,
          src_name: o.ngips_learn_traffic_policy_excpt_host_src_obj_uname,
          src_type: o.ngips_learn_traffic_policy_excpt_host_src_obj_type,
          dst_addr_obj_id: o.ngips_learn_traffic_policy_excpt_dst_addr_obj_id,
          dst_ip_ver: o.ngips_learn_traffic_policy_excpt_host_dst_ip_ver_type,
          dst_name: o.ngips_learn_traffic_policy_excpt_host_dst_obj_uname,
          dst_type: o.ngips_learn_traffic_policy_excpt_host_dst_obj_type
        }
      })
    }
    // ads
    if (_.has(obj, 'ads_lrn_trffc_plc_msg')) {
      this.policy_exc_desc = obj.ads_lrn_trffc_plc_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.src_addr_obj_id,
          src_ip_ver: o.src_ip_ver_type,
          src_name: o.src_obj_uname,
          src_type: o.src_obj_type,
          dst_addr_obj_id: o.dst_addr_obj_id,
          dst_ip_ver: o.dst_ip_ver_type,
          dst_name: o.dst_obj_uname,
          dst_type: o.dst_obj_type
        }
      })
    }
  }
}

export const state = () => ({
  trafficLearningList: [],
  orgTrafficLearningList: []
})

export const mutations = {
  initStore (state) {
    state.trafficLearningList = []
    state.orgTrafficLearningList = []
  },
  /**
   * 단일 정책이 수정되면 스토어를 업데이트한다.
   */
  setTrafficLearning (state, policy) {
    const idx = state.trafficLearningList.findIndex(({learn_traffic_policy_id: id}) => id === policy.learn_traffic_policy_id)

    if (idx > -1) {
      const copy = _.cloneDeep(state.trafficLearningList)
      copy[idx] = policy

      state.trafficLearningList = Object.freeze(copy)
    }
  },
  setTrafficLearningItems (state, rules) {
    const copy = _.cloneDeep(state.trafficLearningList)
    _.forEach(rules, (policy) => {
      const idx = state.trafficLearningList.findIndex(({learn_traffic_policy_id: id}) => id === policy.learn_traffic_policy_id)
      if (idx > -1) copy[idx] = policy
    })
    state.trafficLearningList = Object.freeze(copy)
  },
  /**
   * 예외호스트를 저장한다.
   */
  setHostItems (state, rules) {
    const copy = _.cloneDeep(state.trafficLearningList)
    rules = _.map(rules, o => new PolicyData(o).get())
    _.forEach(rules, (policy) => {
      const idx = state.trafficLearningList.findIndex(({learn_traffic_policy_id: id}) => id === policy.learn_traffic_policy_id)
      if (idx > -1) copy[idx].ex_addr_list = policy.ex_addr_list
    })
    state.trafficLearningList = Object.freeze(copy)
  },
  /**
   * 트래픽 학습 방어 정책 목록을 스토어에 저장한다.
   */
  initTrafficLearningList (state, policyList) {
    state.trafficLearningList = Object.freeze(_.map(policyList, o => new PolicyData(o).get()))
    state.orgTrafficLearningList = _.cloneDeep(state.trafficLearningList)
  },
  /**
   * 원본 데이터를 갱신한다.
   */
  setTrafficLearningList (state, policyList) {
    state.trafficLearningList = Object.freeze(_.cloneDeep(policyList))
  },
  /**
   * 원본 데이터를 갱신한다.
   */
  copyTrafficLearningList (state) {
    state.orgTrafficLearningList = _.cloneDeep(state.trafficLearningList)
  }
}

export const actions = {
  /**
   * 트래픽 학습 정책 목록을 리턴한다.
   */
  async getTrafficLearningList ({rootState, commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/traffics/${id}/policies` : `${cmApiPrefix}/adsprf/defense-learning/traffics/${id}/policies`
      const {code, result, reason} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        commit('initTrafficLearningList', result)
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 트래픽 학습 방어 정책을 설정한다.
   */
  async setTrafficLearningDefense ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/traffics/${id}/policies` : `${cmApiPrefix}/adsprf/defense-learning/traffics/${id}/policies`
      params.items = _.map(params.items, o => new PolicyData(o, modelType).getApiParam())
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 트래픽 학습 정책에 적용된 예외 호스트 정보를 조회한다.
   */
  async getExceptHostDatas ({rootState, commit}, {id, policyId, loading = true, isNotAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/traffics/${id}/policies/${policyId}/exception-ips` : `${cmApiPrefix}/adsprf/defense-learning/traffics/${id}/policies/${policyId}/exception-ips`
      const {code, result} = await this.$axios.$get(url, {loading, isNotAlert})

      if (code === 'ok') {
        res.result = new ExceptHostGetForm(result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 트래픽 학습 정책에 적용된 예외 호스트 정보를 수정한다.
   */
  async setExceptHostDatas ({rootState, commit, dispatch}, {params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const profileId = params.prf_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/defense-learning/traffics/${profileId}/policies/exception-ips` : `${cmApiPrefix}/adsprf/defense-learning/traffics/${profileId}/policies/exception-ips`
      params = new ExceptHostAddForm(params, modelType).getApiParam()
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        if (result.length > 0) {
          commit('setHostItems', result)
        }
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
